import { render } from "./TenantHeader.vue?vue&type=template&id=af9775c4&scoped=true&ts=true"
import script from "./TenantHeader.vue?vue&type=script&lang=ts"
export * from "./TenantHeader.vue?vue&type=script&lang=ts"

import "./TenantHeader.vue?vue&type=style&index=0&id=af9775c4&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9775c4"]])

export default __exports__